<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AYDoSq/tc-custom/9781504094580.jpg?1718106013739" alt="This image is the cover for the book Miracle in March, Tarrin’s Bay"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miracle in March, Tarrin’s Bay
      </h1>
      <p class="bookDescription body article font2">
        <p>Starting again is never easy…<br/>  <br/> Emma had travel plans, but when her family needed help, she stepped in and took over running their business.<br/>  <br/> The beachside cabins in Tarrin’s Bay might not have the same appeal as the French Riviera, but Emma finds happiness in the small-town community.<br/>  <br/> When she finds that her ex-boyfriend, a man she left behind without explanation, is staying in one of the cabins, her tranquil existence is shattered.<br/>  <br/> She knows she must share the secret she has been hiding for five years, but that’s easier said than done. And James has his own confession to make…<br/>  <br/> They aren’t the same people they were before, but is it time for a second chance? And when their secrets surface, might two people in need of a miracle remember the dreams they once had and be able to move on?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Juliet Madison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29415252